import { consoleSandbox } from '@sentry/core';
import { captureException } from '@sentry/svelte';

// The SvelteKit default error handler just logs the error to the console
// see: https://github.com/sveltejs/kit/blob/369e7d6851f543a40c947e033bfc4a9506fdc0a8/packages/kit/src/core/sync/write_client_manifest.js#LL127C2-L127C2
function defaultErrorHandler({ error }) {
  consoleSandbox(() => {
    // eslint-disable-next-line no-console
    console.error(error);
  });
}

/**
 * Wrapper for the SvelteKit error handler that sends the error to Sentry.
 *
 * @param handleError The original SvelteKit error handler.
 */
function handleErrorWithSentry(handleError = defaultErrorHandler) {
  return (input) => {
    // SvelteKit 2.0 offers a reliable way to check for a 404 error:
    if (input.status !== 404) {
      captureException(input.error, {
        mechanism: {
          type: 'sveltekit',
          handled: false,
        },
      });
    }

    // We're extra cautious with SafeHandleServerErrorInput - this type is not compatible with HandleServerErrorInput
    // @ts-expect-error - we're still passing the same object, just with a different (backwards-compatible) type
    return handleError(input);
  };
}

export { handleErrorWithSentry };
//# sourceMappingURL=handleError.js.map
